import { FormSection, Radio } from '@ksyos/design-system';
import type { AssetCategory } from '@common/enums';
import type { OsasEvaluationData } from '@common/validation/customControls/osas/osasEvaluationSchemas/types';
import { YesOrNoOrUnknown } from '@common/enums';
import { useProcessActivityEditContext } from '@frontend/utils';
import { ProcessActivityAssetsDropzone } from '../../../processActivityAssets/ProcessActivityAssetsDropzone';
import { RadioGroupFormGroup } from '../../../processActivityFormGroupFields';

type PatientFollowsPolicyWithAttachmentFormSectionProps = {
    assetCategory: AssetCategory;
    patientFollowsPolicyFieldKey: keyof OsasEvaluationData;
    title: string;
};

export function PatientFollowsPolicyWithAttachmentFormSection(
    props: Readonly<PatientFollowsPolicyWithAttachmentFormSectionProps>
) {
    const { assetCategory, patientFollowsPolicyFieldKey, title } = props;
    const { data, onChange } = useProcessActivityEditContext<OsasEvaluationData>();

    return (
        <FormSection title={title}>
            <RadioGroupFormGroup
                fieldKey={patientFollowsPolicyFieldKey}
                label="Volgt patiënt het beleid?"
                onChange={async (value) => {
                    onChange(
                        { [patientFollowsPolicyFieldKey]: value as YesOrNoOrUnknown },
                        patientFollowsPolicyFieldKey
                    );
                }}
                radioGroupLayout="column"
                value={(data[patientFollowsPolicyFieldKey] as YesOrNoOrUnknown) ?? undefined}
            >
                <Radio
                    key={YesOrNoOrUnknown.yes}
                    label={YesOrNoOrUnknown.yes}
                    value={YesOrNoOrUnknown.yes}
                />

                <Radio
                    key={YesOrNoOrUnknown.no}
                    label={YesOrNoOrUnknown.no}
                    value={YesOrNoOrUnknown.no}
                />

                <Radio
                    key={YesOrNoOrUnknown.unknown}
                    label={YesOrNoOrUnknown.unknown}
                    value={YesOrNoOrUnknown.unknown}
                />
            </RadioGroupFormGroup>

            <ProcessActivityAssetsDropzone
                assetCategory={assetCategory}
                label="Bijlage"
            />
        </FormSection>
    );
}
